import Route from '@ember/routing/route';

export default class AuthenticatedPlaylistsShowTeamsRoute extends Route {}
